export const CONSTANTS  = {
    'AUTHOR': 'Roshmeet Chakraborty',
    'AUTHOR_GITHUB_LINK': 'https://youtu.be/xvFZjo5PgG0',
    'AUTHOR_LINKEDIN_LINK': 'https://www.linkedin.com/in/roshmeet/',
}